import React, { useEffect, useRef, useState } from "react";
import { oauth } from "../../utils";
import { useShipStationAlert } from "../../hooks/useShipstationAlert";
import IntegrationCredentialsForm from "./IntegrationCredentialsForm";

const ShipStationIntegration = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isTestingConnection, setIsTestingConnection] =
    useState<boolean>(false);
  const [statusCode, setStatusCode] = useState<number | null>(null);
  const [apiKey, setApiKey] = useState<string>("");
  const [apiSecret, setApiSecret] = useState<string>("");
  const apiKeyRef = useRef<string>("");
  const apiSecretRef = useRef<string>("");

  useEffect(() => {
    const checkConnection = async () => {
      try {
        const connectionCheck = await oauth("GET", "shipstation-settings", {});
        setStatusCode(connectionCheck?.response?.status);
        const key = connectionCheck?.json?.key || "";
        const secret = connectionCheck?.json?.secret || "";
        setApiKey(key);
        setApiSecret(secret);
        apiKeyRef.current = key;
        apiSecretRef.current = secret;
        setIsLoading(false);
      } catch (error) {
        console.error("Failed to test connection:", error);
        setStatusCode(error?.response?.status);
        setIsLoading(false);
      }
    };

    checkConnection();
  }, []);

  const testConnection = async () => {
    setIsTestingConnection(true);
    try {
      const connectionCheck = await oauth("PUT", "shipstation-settings", {
        key: apiKey.trim(),
        secret: apiSecret.trim(),
      });
      setStatusCode(connectionCheck?.response?.status);
      const key = connectionCheck?.json?.key || "";
      const secret = connectionCheck?.json?.secret || "";
      setApiKey(key);
      setApiSecret(secret);
      apiKeyRef.current = key;
      apiSecretRef.current = secret;
      setIsTestingConnection(false);
    } catch (error) {
      console.error("Failed to connect shipstation:", error);
      setStatusCode(error?.response?.status);
      setIsTestingConnection(false);
    }
  };

  const hasInputValuesChanged =
    apiKey !== apiKeyRef.current || apiSecret !== apiSecretRef.current;
  const isButtonDisabled =
    !apiKey || !apiSecret || isTestingConnection || !hasInputValuesChanged;

  const { alertMessage, alertType } = useShipStationAlert({
    statusCode,
  });

  return (
    <IntegrationCredentialsForm
      isLoading={isLoading}
      alertType={alertType}
      alertMessage={alertMessage}
      fields={[
        {
          label: "API Key",
          value: apiKey,
          onChange: setApiKey,
        },
        {
          label: "API Secret",
          value: apiSecret,
          onChange: setApiSecret,
        },
      ]}
      submitLabel="Test Connection"
      isSubmitting={isTestingConnection}
      isSubmitDisabled={isButtonDisabled}
      onSubmit={testConnection}
      submittingSpinnerStyle={{ margin: "auto 42px" }}
    />
  );
};

export default ShipStationIntegration;
